import { StateSchema } from 'app/config/storeConfig/types';
import { WaitingListEntryDrawerSchema } from '../types';

export const getWaitingListEntryDrawerState = (state: StateSchema): WaitingListEntryDrawerSchema => state.waitingListEntryDrawer;
